import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Button, Col, InputNumber, Row, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { reportData } from '@app/services'
import { Typography } from 'antd'
import html2canvas from 'html2canvas'
import { useETHDAIBalance, useETHUSDCBalance, useETHUSDTBalance } from 'libs/services/hooks/useCSTBalance'
import useFee from 'libs/services/hooks/useFee'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { OffSummary } from './off-summary'
// import { IStore } from '@app/redux'
// import { useSelector } from 'react-redux'
import { PaymentMethodCollapse } from './payment-method-collapse'

const { Title } = Typography
// import { errorHandler } from '@app/services'

export const OnRampDrawer: React.FC<{ isForDrawer?: boolean }> = () => {
  const { usa, fetchUserInfo } = useContext(UserInfoContext)

  const [amount, setAmount] = useState(0)
  const [receiveAmount, setReceiveAmount] = useState(0)
  const [wireTransactionType, setWireTransactionType] = useState('wire-instructions-intl')
  const [stablecoinType, setStablecoinType] = useState('USDC')
  const [fund, setFund] = useState('')
  const [selectedPanel, setSelectedPanel] = useState(usa ? '2' : '8')
  const [selectedMethod, setSelectedMethod] = useState<any>({ name: '', val: '' })
  const [setCurrentNode] = useState<any>()
  const stablecoinBalance = [useETHUSDCBalance(false), useETHUSDTBalance(false), useETHDAIBalance(false)]

  useEffect(() => {
    fetchUserInfo()
  }, [])

  const { user } = useSelector((state: IStore) => state)

  //const [accounts, setAccounts] = useState([])

  const fee = useFee()

  useEffect(() => {
    setAmountCheck(amount)
  }, [selectedPanel, wireTransactionType])

  //   useEffect(() => {
  //     const fetchBalance = async () => {
  //       if (!) {
  //         setStablecoinBalance('Connect Your Wallet')
  //         return
  //       }
  //       if (stablecoinType == 'USDC') {
  //         await usdcBalance(, setStablecoinBalance)
  //       } else if (stablecoinType == 'USDT') {
  //         await usdtBalance(, setStablecoinBalance)
  //       } else if (stablecoinType == 'DAI') {
  //         await daiBalance(, setStablecoinBalance)
  //       } else {
  //         setStablecoinBalance(0)
  //       }
  //     }
  //     fetchBalance()
  //   }, [stablecoinType, ])

  async function setAmountCheck(value) {
    if (value) {
      setAmount(value)
      if (selectedPanel == '1') {
        if (wireTransactionType == 'wire-instructions') {
          setReceiveAmount(value)
        } else {
          setReceiveAmount(value)
        }
      } else if (selectedPanel == '2') {
        setReceiveAmount(value)
      } else if (selectedPanel == '3') {
        setReceiveAmount(value - 3)
      } else if (selectedPanel == '4') {
        setReceiveAmount(value)
      } else if (selectedPanel == '8') {
        setReceiveAmount(value)
      } else if (selectedPanel == '5') {
        setAmount(value)
        setReceiveAmount(value - (value * fee) / 100)
      } else {
        setReceiveAmount(0)
      }
    } else {
      setAmount(0)
      setReceiveAmount(0)
    }
  }

  const handleImageSave = async (node: any) => {
    //const node = componentRef.current
    html2canvas(node).then((canvas) => {
      const link = document.createElement('a')
      link.download = 'CoastWiringDetails.png'
      link.href = canvas.toDataURL()
      link.click()
      //   errorHandler.report`User {${user.email}} downloaded wiring details, they're amount is {${amount}}`
    })
    await reportData(`User ${user.email} downloaded wiring details`, `User ${user.uid} downloaded wiring details.`)
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        {process.env.NEXT_PUBLIC_DEPOSIT_ON == 'true' && (
          <>
            <Col span={24}>
              <Text>Select deposit method</Text>
            </Col>
            <Col span={24}>
              <PaymentMethodCollapse
                fund={fund}
                setFund={setFund}
                selectedPanel={selectedPanel}
                setSelectedPanel={setSelectedPanel}
                wireTransactionType={wireTransactionType}
                setWireTransactionType={setWireTransactionType}
                selectedMethod={selectedMethod}
                setSelectedMethod={setSelectedMethod}
                setCurrentNode={setCurrentNode}
                stablecoinType={stablecoinType}
                setStablecoinType={setStablecoinType}
                handleImageSave={handleImageSave}
                stablecoinBalance={stablecoinBalance}
              />
            </Col>

            {selectedPanel == '5' && (
              <>
                <Col span={24}>
                  <Text>Amount</Text>
                  {selectedPanel == '5' && (
                    <Button
                      type="link"
                      onClick={() => {
                        setAmountCheck(
                          stablecoinBalance[0].state == 'enabled'
                            ? Number(
                              stablecoinBalance[stablecoinType == 'USDC' ? 0 : stablecoinType == 'USDT' ? 1 : 2]
                                .value,
                            ) /
                                10 ** (stablecoinType == 'DAI' ? 18 : 6)
                            : 0,
                        )
                      }}
                    >
                      Max
                    </Button>
                  )}
                </Col>
                <Col span={24}>
                  <InputNumber
                    onChange={(e: number) => {
                      setAmountCheck(e)
                    }}
                    addonBefore={'$'}
                    value={amount > 0 ? amount : ''}
                    width={'100%'}
                    placeholder={'Enter amount to deposit into digital account'}
                  />
                </Col>

                <Spacer value={30} />

                <Col span={24}>
                  {/*<Summary
                    amount={amount}
                    receiveAmount={receiveAmount}
                    selectedPanel={selectedPanel}
                    fee={fee}
                    open={modalOpen}
                    toggleOpen={() => setModalOpen(false)}
                    fund={fund}
                    wireTransactionType={wireTransactionType}
                    refresh={null}
                    toggleOpenParent={null}
                    selectedMethod={selectedMethod}
                    handleImageSave={handleImageSave}
                    currentNode={currentNode}
                    stablecoinType={stablecoinType}
                    stablecoinBalance={stablecoinBalance}
                  />*/}

                  <OffSummary
                    purchaseData={{
                      pay: {
                        amount: amount,
                        setAmount: setAmountCheck,
                        type: stablecoinType,
                        setType: setStablecoinType,
                      },
                      receive: {
                        amount: receiveAmount,
                        setAmount: setReceiveAmount,
                        type: 'USD',
                        setType: null,
                      },
                    }}
                    coastBalance={
                      stablecoinBalance[0].state == 'enabled'
                        ? Number(
                          stablecoinBalance[stablecoinType == 'USDC' ? 0 : stablecoinType == 'USDT' ? 1 : 2].value,
                        ) /
                          10 ** (stablecoinType == 'DAI' ? 18 : 6)
                        : 0
                    }
                    fee={fee}
                    balance={0}
                    setFee={undefined}
                  />
                </Col>
              </>
            )}

            <Spacer value={30} />

            <Col span={24}>
              {/* Disclaimer */}
              <Title level={1}>Disclaimer:</Title>

              {/* General */}
              <Title level={5}>General</Title>
              <Text>
                Most deposits are charged a $3.00 processing fee. This is dependent on the funding method you select.
              </Text>

              {/* Old Glory */}
              <Title level={5}>Old Glory</Title>
              <Text>
                Both deposits and withdraws made through Old Glory Pay are fee-free. Please remember to download the Old
                Glory Pay app on your mobile device. This is NOT the same as the regular Old Glory banking app.
              </Text>

              {/* Zelle */}
              <Title level={5}>Zelle</Title>
              <Text>
                All Zelle deposits are currently processed manually. We are working on a secure way to automate this
                process to allow for near-instant deposits. For now, expect at least 2 hours for processing during
                regular US banking hours.
              </Text>
              <br />
              <Text strong>
                NOTE: We check the customer service chat on weekends. If you've sent a Zelle deposit outside banking
                hours, use the chat feature and we may be able to clear it for you.
              </Text>

              {/* Wire transfer */}
              <Title level={5}>Wire transfer</Title>
              <Text>
                We aim to process all Wire Transfers within 2 hours of receipt. Please note that we can only achieve
                this during US banking hours. If you schedule a Wire Transfer on a Saturday morning EST it's extremely
                unlikely that we would be able to process this deposit before Midday on the following Monday.
              </Text>

              {/* ACH */}
              <Title level={5}>ACH</Title>
              <Text>
                Most online banking software allows you to send an ACH payment to an external account. These payments
                often require either an additional ACH agreement with your bank OR the use of a Bill Pay feature. If you
                have specific questions about how to do this using your bank, please use our support chat and we will
                provide assistance.
              </Text>

              {/* Wise */}
              <Title level={5}>Wise</Title>
              <Text>
                Most Wise deposits are received within 4-12 hours and processed within 24-48 hours. Please note that our
                depository banks sometimes hold funds for longer than this. If you read the fine print on the Wise
                website, they typically remind you that your funds might not be available for 3-5 business days
                depending on when they are sent.
              </Text>
              <br />
              <Text>
                If you have sent a deposit and it has not been credited within 2 business days, please use our support
                chat and we will provide assistance.
              </Text>

              {/* Revolut */}
              <Title level={5}>Revolut</Title>
              <Text>
                Most Revolut deposits are received within 4-12 hours and processed within 24-48 hours. Please note that
                our depository banks sometimes hold funds for longer than this. If you read the fine print on the
                Revolut website, they typically remind you that your funds might not be available for 3-5 business days
                depending on when they are sent.
              </Text>
              <br />
              <Text>
                If you have sent a deposit and it has not been credited within 2 business days, please use our support
                chat and we will provide assistance.
              </Text>

              {/* Ethereum Stablecoins */}
              <Title level={5}>Ethereum Stablecoins</Title>
              <Text>
                You are able to bypass the official PulseChain bridge by making an Ethereum stablecoin deposit (USDT,
                USDC or DAI). We aim to process these deposits within 8-10 minutes. But these transactions can fail or
                be delayed due to network congestion and RPC infrastructure. If your deposit has taken longer than 30
                minutes, please copy your transaction hash from your wallet (etherscan.io link) and paste it in support
                chat and we will provide assistance.
              </Text>

              {/* Final Thoughts */}
              <Title level={5}>Final Thoughts</Title>
              <Text>
                You may have noticed that there is nowhere to "link a bank account" on this page. We know that this is
                not an ideal user-experience. But given the risk of fraud and the damage to the general public of this
                payment method, we have decided not to use it. Thanks for your understanding.
              </Text>
            </Col>
          </>
        )}
        {process.env.NEXT_PUBLIC_DEPOSIT_ON != 'true' && (
          <Col span={24}>
            <Text>
              Deposits are temporarilty turned off. Please monitor your email for updates on the process and the
              re-release of this feature. Thanks, Management.
            </Text>
          </Col>
        )}
      </Row>
    </>
  )
}
